import React, { useMemo, useEffect, useState } from "react";
import "./styles.less";
import { useTranslation } from "react-i18next";
import classNames from "classnames";
import { AuthingButton } from "../../../../components/AuthingButton";

export const ManufacturingBanner = () => {
  const { t } = useTranslation();
  const titles = useMemo(() => {
    return [
      {
        title: t("car.banner.title"),
        subtitle: t("car.banner.subtitle"),
      },
    ];
  }, [t]);
  const orders = useMemo(() => {
    return [
      {
        imgUrl: "https://files.authing.co/authing-website/car--toyota.png",
        alt: "",
        linkIndex: 3,
      },
      {
        imgUrl: "https://files.authing.co/authing-website/car--volkswagen.png",
        alt: "",
        linkIndex: 2,
      },
      {
        imgUrl: "https://files.authing.co/authing-website/car--siweituxin.png",
        alt: "",
      },
      {
        imgUrl: "https://files.authing.co/authing-website/car--continental.png",
        alt: "",
      },
      {
        imgUrl: "https://files.authing.co/authing-website/car--porsche.png",
        alt: "",
        linkIndex: 0,
      },
      {
        imgUrl: "https://files.authing.co/authing-website/car--bentley.png",
        alt: "",
        linkIndex: 4,
      },
      {
        imgUrl: "https://files.authing.co/authing-website/car--bosch.png",
        alt: "",
        linkIndex: 4,
      },
      // {
      //   imgUrl: "https://files.authing.co/authing-website/car--landrover.png",
      //   alt: "",
      //   linkIndex: 4,
      // },
      {
        imgUrl: "https://files.authing.co/authing-website/car--goodyear.png",
        alt: "",
        linkIndex: 4,
      },
    ];
  }, []);
  const [currentIndex, setCurrentIndex] = useState(0);
  useEffect(() => {
    const timer = setInterval(() => {
      if (currentIndex < titles.length - 1) {
        setCurrentIndex(currentIndex + 1);
      } else {
        setCurrentIndex(0);
      }
    }, 5000);
    return () => clearInterval(timer);
  }, [currentIndex, titles]);
  const tabWrapper = useMemo(() => {
    return (
      <div className="manufacturing-banner-carousel-container-order swiper-wrapper">
        {[...orders, ...orders].map((order, index) => {
          return (
            <div
              className={classNames("container-order swiper-slide")}
              key={index}
            >
              <img src={order.imgUrl} alt={order.alt} />
            </div>
          );
        })}
      </div>
    );
  }, [orders]);

  useEffect(() => {
    new Swiper(".manufacturing-banner-swiper", {
      spaceBetween: 24,
      slidesPerView:
        JSON.parse(sessionStorage.getItem("windowWidth")) > 1200 ? 6 : 4,
      // slidesPerView: "auto",
      loop: true,
      // centeredSlides: true,
      autoplay: {
        delay: 2500,
        disableOnInteraction: false,
      },
    });
  }, []);
  const openROI = () => {
    window.open("https://roi.authing.cn/");
  };
  return (
    <div className="car-banner">
      <div className="manufacturing-banner-carousel-container-warp">
        {titles.map((item, index) => {
          const className = classNames({
            "manufacturing-banner-carousel-container": true,
            visible: currentIndex === index,
          });
          return (
            <div className={className} key={index}>
              <div className="container-item basic-column">
                <h1 className="slogn">{item.title}</h1>
                <div className="descrption">{item.subtitle}</div>

                <AuthingButton
                  style={{ marginRight: 24 }}
                  onClick={() => {
                    // setVisible(true);
                    window.open(
                      "https://www.authing.cn/authingform?fromTag=汽车行业"
                    );
                  }}
                >
                  {t("common.button.consult")}
                </AuthingButton>
                <AuthingButton mode="light" onClick={openROI}>
                  {t("common.button.try-now-roi")}
                </AuthingButton>
              </div>
            </div>
          );
        })}
        <div className="manufacturing-banner-carousel-container-order-wrap">
          <div className="basic-column">
            <div className="swiper manufacturing-banner-swiper">
              {tabWrapper}
            </div>
          </div>
          {/* <div class="pad-show mobile-show">{tabWrapper}</div> */}
        </div>
      </div>
    </div>
  );
};
